import { useState } from 'react';
import { useSfx } from '../../../lib/sfx/index.js';
import { iconSvg } from './shipArt.js';
import { SHIP_PIECES } from './pieces.js';
import { ShipIntroScene } from './ShipScene.js';
import './ship.css';

/**
 * La presentación de «Armá tu nave» (la primera vez que entra al Inicio, `status = pending`): la
 * nave con sus 7 piezas, qué es cada una y dos salidas — empezar o «Ahora no» (la nave lo espera en
 * el Perfil). El fondo y el contenido se funden por turnos: la nave nunca queda a medio ver encima
 * de los textos del Inicio (revisión del encargo 109).
 */
export function ShipIntro({
  variant,
  onStart,
  onLater,
  onClosed,
}: {
  variant: 'mobile' | 'desktop';
  onStart: () => Promise<void>;
  onLater: () => Promise<void>;
  /** Terminó de irse (el Inicio la desmonta recién acá, para que el fundido termine). */
  onClosed: () => void;
}) {
  const { play } = useSfx();
  const [leaving, setLeaving] = useState(false);
  const [gone, setGone] = useState(false);

  const leave = async (then: () => Promise<void>) => {
    if (leaving) return;
    setLeaving(true);
    // Primero se va la nave; con el fondo todavía tapando, el Inicio cambia; después el fondo.
    await new Promise((ok) => setTimeout(ok, 200));
    await then().catch((err: unknown) => console.warn('[ship] presentación', err));
    setGone(true);
    await new Promise((ok) => setTimeout(ok, 220));
    onClosed();
  };

  return (
    <div
      className={`ship-intro${variant === 'desktop' ? ' is-desk' : ''}${leaving ? ' is-leaving' : ''}${gone ? ' is-gone' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="ship-intro-t"
    >
      <div className="ship-intro-box">
        <ShipIntroScene />
        <div className="ship-intro-k">Antes de empezar</div>
        <div className="ship-intro-t" id="ship-intro-t">
          Armá tu nave
        </div>
        <p className="ship-intro-s">
          Orborix tiene 7 herramientas para practicar inglés. Cada una que probás es una{' '}
          <b>pieza de tu nave</b>. Con las 7, despegás.
        </p>
        <ul className="ship-intro-list">
          {SHIP_PIECES.map((p) => (
            <li key={p.id} className={`ship-c-${p.medium}`}>
              <span className="ship-ic" dangerouslySetInnerHTML={{ __html: iconSvg(p.medium) }} />
              <span>
                <b>{p.name}</b>
                <small>{p.feature}</small>
              </span>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="ship-cta"
          onClick={() => {
            play('ship-piece');
            void leave(onStart);
          }}
        >
          Empezar a armar
        </button>
        <button type="button" className="ship-intro-later" onClick={() => void leave(onLater)}>
          Ahora no: la nave te espera en Perfil
        </button>
      </div>
    </div>
  );
}
